export default "__VITE_ASSET__CoC3fvOG__"